import { EntitySortOrder } from '../enums';
import type { Persona } from '../types';

export type PersonaDateField = 'created_at' | 'updated_at';

export function comparePersonasBySortOrder(
  a: Persona,
  b: Persona,
  sortOrder: EntitySortOrder,
  dateField: PersonaDateField = 'updated_at',
): number {
  if (sortOrder === EntitySortOrder.Alphabetical) {
    return a.name.localeCompare(b.name);
  }
  return new Date(b[dateField]).getTime() - new Date(a[dateField]).getTime();
}
